<template>
  <Modal :id="id" title="Total Hours" :hide-footer="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row mb-3">
        <div class="col-12 text-center">
          <h3 v-if="viewBy == 'user'">{{ user.name }}</h3>
          <h3 v-else>{{ company.name }}</h3>
        </div>
      </div>

      <div class="row mb-3">
        <div v-if="showViewByDropdown" class="col-6">
          <Field
            type="select"
            name="view_by"
            label="View by"
            v-model="viewBy"
            :options="viewByOptions"
            :hide-select-empty-option="true"
          />
        </div>
        <div class="col-6">
          <Field
            type="select"
            name="year"
            label="Year"
            v-model="year"
            :options="yearOptions"
            :hide-select-empty-option="true"
          />
        </div>
      </div>

      <template v-if="hours.length > 0">
        <div class="row hours-row">
          <div class="col-12">
            <div class="listable">
              <div
                v-for="(item, i) in hours"
                :key="i"
                v-show="!isIgnored(item)"
                class="listable-data"
              >
                <div class="td text-uppercase fs-2">{{ item.category }}</div>
                <div class="td text-primary text-right font-weight-bold">
                  {{ item.hours }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="loaded">
        <p class="text-center">No hours are recorded for the selected year.</p>
      </template>

      <div class="row mt-3">
        <div class="col-12">
          <p class="text-center">
            To view training details, please
            <a :href="route('training.history.index', { type: 'online' })"
              >click here</a
            >. Company hours totals calculate every 4 hours, beginning at 12AM EST.
          </p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";

export default {
  mixins: [ModalMixin],

  data() {
    return {
      id: "hours-modal",
      user: this.$root.user,
      company: this.$root.company,
      hours: [],
      viewBy: "company",
      year: new Date().getFullYear(),
      minYear: new Date().getFullYear(),
      maxYear: new Date().getFullYear(),
      ignore: ["Factory Select Product"],
      loaded: false,
    };
  },

  computed: {
    isCurrentUser() {
      return !!this.user && this.user.id == this.$root.user.id;
    },
    showViewByDropdown() {
      return !!this.user;
    },
    viewByOptions() {
      return [
        {
          value: "user",
          label: this.isCurrentUser ? "My Hours" : "User Hours",
        },
        {
          value: "company",
          label: "Company Hours",
        },
      ];
    },
    yearOptions() {
      var options = [];
      var current = new Date().getFullYear();
      for (var y = this.minYear; y <= this.maxYear; y++) {
        options.push({ value: y, label: y });
      }
      if (this.maxYear < current) {
        options.push({ value: current, label: current });
      }
      return options;
    },
    routeName() {
      if (this.viewBy == "user" && !!this.user) {
        return "training.users.hours";
      } else {
        return "training.companies.hours";
      }
    },
    routeVars() {
      if (this.viewBy == "user" && !!this.user) {
        return { user: this.user.id, year: this.year };
      } else {
        return { company: this.company.id, year: this.year };
      }
    },
  },

  watch: {
    viewBy(val) {
      this.year = new Date().getFullYear();
      this.init();
    },
    year(val) {
      this.load();
    },
  },

  methods: {
    init: _.debounce(function () {
      this.loaded = false;
      var route = this.route(this.routeName, this.routeVars);
      this.axios
        .get(route, {
          params: {
            get_year_range: true,
          },
        })
        .then((response) => {
          this.minYear = response.data.min_year;
          this.maxYear = response.data.max_year;
          this.$nextTick(() => {
            if (!this.loaded) {
              this.load();
            }
          });
        });
    }, 300),
    load: _.debounce(function () {
      this.loaded = false;
      var route = this.route(this.routeName, this.routeVars);
      this.axios.get(route).then((response) => {
        this.hours = response.data.hours;
        this.loaded = true;
      });
    }, 300),
    isIgnored(item) {
      return _.includes(this.ignore, item.category);
    },
    isSpaced(item) {
      return _.includes(this.spaced, item.category);
    },
  },

  mounted() {
    if (_.has(this.options, "user") && _.isObject(this.options.user)) {
      this.user = _.cloneDeep(this.options.user);
      this.company = _.cloneDeep(this.user.company);
      this.viewBy = "user";
    } else if (
      _.has(this.options, "company") &&
      _.isObject(this.options.company)
    ) {
      this.user = null;
      this.company = _.cloneDeep(this.options.company);
      this.viewBy = "company";
      this.init();
    } else {
      this.init();
    }
  },
};
</script>
<style lang="scss">
	.hours-row {
		.listable {
			width: 100%;
			display: table;

			.listable-head,
			.listable-data {
				display: table-row;
			}

			.th,
			.td {
				display: table-cell;
			}

			.listable-data {
				background-color: #ffffff;
				box-shadow: 0 2px 10px -2px gray("500");
				margin-bottom: 0.5rem;

				&:hover {
					background-color: gray("200");
				}

			}
		}
	}
</style>